// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_tt1","cls2":"SuggestedUserCard-cls2__F3 SuggestedUserCard-cls1_tt1"};